import { useState } from 'react';

import {
  useChatWindowListeners,
  useCohortDefinitionListeners,
  useResearchAssistantConnectionListeners,
} from '@verantos-dev/feature-research-assistant';

import { useCohortBuilderPagePreFetch } from './initialization/useCohortBuilderPagePreFetch';
import { useCohortBuilderSkeleton } from './initialization/useCohortBuilderSkeleton';
import { useRedirectOnInvalidParams } from '../hooks/initialization/useRedirectOnInvalidParams';

export const useCohortBuilderPage = () => {
  // Verify params
  useRedirectOnInvalidParams();

  // initialize page data
  const { isFinalFetchTimerActive } = useCohortBuilderPagePreFetch();
  const { isCohortProfileLoading } = useCohortBuilderSkeleton();

  // Initialize Research Assistant listeners
  useResearchAssistantConnectionListeners();
  useChatWindowListeners();
  useCohortDefinitionListeners();

  // TODO: handle cohort DSL version
  const [cohortDslVersion] = useState<number>(0);

  return {
    cohortDslVersion,
    isCohortProfileLoading,
    isFinalFetchTimerActive,
  };
};
